lmApp
  .service('InfrastructureService', ['$q', '$http', function ($q, $http) {
    var service = {};

    /**
     * Get Origins
     * @returns {*|Deferred|number}
     * @constructor
     */
    service.GetOrigins = function () {
      var deferred = $q.defer();

      lh.common.request('collection/origin/query' + '?t=' + Date.now())
        .then(function (response) {
          deferred.resolve(response.collection);
        }, function (reason) {
          reason.url = 'collection/resource_group/query' + '?t=' + Date.now();
          reason.data = 'GET';
          deferred.reject(reason)
        });

      return deferred.promise;
    };

    /**
     * Get resource groups
     * @returns {*|Deferred|number}
     * @constructor
     */
    service.GetResourceGroups = function () {
      var deferred = $q.defer();

      lh.common.request('collection/resource_group/query' + '?t=' + Date.now())
        .then(function (response) {
          deferred.resolve(response.collection);
        }, function (reason) {
          reason.url = 'collection/resource_group/query' + '?t=' + Date.now();
          reason.data = 'GET';
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    /**
     * Update origin
     * @param origin
     * @returns {*|Deferred|number}
     * @constructor
     */
    service.UpdateOrigin = function (origin) {
      var deferred = $q.defer();

      var data = {
        origin_id: origin.id,
        cdn_url: origin._PrivateData.cdnUrl
      };

      lh.common.request.post('origin/mgmt/update', data)
        .then(function (response) {
          deferred.resolve(response.collection);
        }, function (reason) {
          reason.url = 'origin/mgmt/update';
          reason.data = data;
          deferred.reject(reason)
        });

      return deferred.promise;
    };

    /**
     * Update resource delivery method: origin | cdn | direct
     * @param group
     * @returns {*|Deferred|number}
     * @constructor
     */
    service.UpdateResource = function (group) {
      var deferred = $q.defer();

      var data = {
        group_id: group.id,
        delivery_method: group._PrivateData.method
      };

      lh.common.request.post('resource/mgmt/group/update', data)
        .then(function (response) {
          deferred.resolve(response.collection);
        }, function (reason) {
          reason.url = 'resource/mgmt/group/update';
          reason.data = data;
          deferred.reject(reason)
        });

      return deferred.promise;
    };

    service.monitoringRequest = function (expr, range, step, end) {
      var deferred = $q.defer();

      var data = {
        end: end || 0,
        expr: expr,
        range: range || 3600,
        step: step || 5
      };

      $http({
        url: '/monitoring/query_range',
        method: "GET",
        params: data
      })
        .then(function (response) {
          if (response.status == 200) {
            if (response.data.type === 'error') {
              deferred.reject(response.data)
            } else {
              deferred.resolve(response.data);
            }
          } else {
            deferred.reject(response)
          }
        }, function (reason) {
          reason.url = '/monitoring/query_range';
          reason.data = data;
          deferred.reject(reason)
        });

      return deferred.promise;
    };

    return service;
  }]);
